// extracted by mini-css-extract-plugin
export var searchHeader = "_6q-0";
export var searchHeaderDark = "_6q-1";